import { render, staticRenderFns } from "./CablePrices.vue?vue&type=template&id=6558520e"
import script from "./CablePrices.vue?vue&type=script&lang=js"
export * from "./CablePrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports